import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        outline: "text-foreground",
        info: "border-transparent bg-info text-info-foreground shadow hover:bg-info/80",
        success: "border-transparent bg-success text-success-foreground shadow hover:bg-success/80",
        warning: "border-transparent bg-warning text-warning-foreground shadow hover:bg-warning/80",
        danger: "border-transparent bg-danger text-danger-foreground shadow hover:bg-danger/80",
        dark: "border-transparent bg-dark text-dark-foreground shadow hover:bg-dark/90",
        white: "border-white-custom-border bg-white-custom text-white-custom-foreground shadow hover:bg-white-custom/90",
        muted: "border-transparent bg-muted text-muted-foreground shadow hover:bg-muted/80",
        "soft": "border-transparent bg-primary/10 text-primary hover:bg-primary/20",
        "soft-primary": "border-transparent bg-primary/10 text-primary hover:bg-primary/20",
        "soft-secondary": "border-transparent bg-secondary/50 text-secondary-foreground hover:bg-secondary/80",
        "soft-info": "border-transparent bg-info/10 text-info hover:bg-info/20",
        "soft-success": "border-transparent bg-success/10 text-success hover:bg-success/20",
        "soft-warning": "border-transparent bg-warning/10 text-warning hover:bg-warning/20",
        "soft-danger": "border-transparent bg-danger/10 text-danger hover:bg-danger/20",

        "outline-primary": "border-primary text-primary hover:bg-primary/10",
        "outline-secondary": "border-secondary text-secondary-foreground hover:bg-secondary/50",
        "outline-info": "border-info text-info hover:bg-info/10",
        "outline-success": "border-success text-success hover:bg-success/10",
        "outline-warning": "border-warning text-warning hover:bg-warning/10",
        "outline-danger": "border-danger text-danger hover:bg-danger/10",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
})
Badge.displayName = "Badge"

export { Badge, badgeVariants }
